import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaSave } from "react-icons/fa";

const Cateringbillingsetup = () => {
    const billingFields = [
        { label: "Commission", key: "commission" },
        { label: "Commission GST", key: "commissionGst" },
        { label: "GST", key: "gst" },
        { label: "Platform Fee", key: "platformFee" },
        { label: "Catering Fee", key: "leadPercentage" },
        { label: "Delivery Fee per km", key: "deliveryFeeperkm" },
        { label: "Partial Payment", key: "partialPayment" },
        { label: "TopRated Fee", key: "topRated" },
    ];

    const [billingData, setBillingData] = useState({});
    const [editMode, setEditMode] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchBillingData();
    }, []);

    const fetchBillingData = async () => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.error("❌ Auth token not found in localStorage");
                return;
            }

            const url =
                "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/billing/get";
            const response = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const data = response.data || {};
            console.log("📦 Billing API response:", data);

            const initializedData = billingFields.reduce((acc, { key }) => {
                acc[key] = Number(data[key]) || 0;

                // Handle API typo for 'commission'
                const backendKey =
                    key === "commission" ? "commisionApplicable" : `${key}Applicable`;

                const val = data[backendKey];
                acc[`${key}Applicable`] = val === true || val === "true" || val === 1;

                return acc;
            }, { id: data.id || 0 });

            setBillingData(initializedData);
        } catch (error) {
            console.error("❌ Error fetching billing data:", error);
        }
    };


    const toggleEdit = (key) => {
        setEditMode((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const handleValueChange = (key, value) => {
        setBillingData((prev) => ({ ...prev, [key]: value }));
    };

    const handleCheckboxChange = (key) => {
        const applicableKey = `${key}Applicable`;
        setBillingData((prev) => ({
            ...prev,
            [applicableKey]: !prev[applicableKey],
        }));
    };

    const handleSaveOrUpdate = async (key) => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("⚠️ Auth token missing");
                setLoading(false);
                return;
            }

            // Build payload dynamically with backend key fix
            const payload = { id: billingData.id || 0 };

            billingFields.forEach(({ key }) => {
                payload[key] = Number(billingData[key]) || 0;

                // Fix backend typo for commissionApplicable
                const backendKey =
                    key === "commission" ? "commisionApplicable" : `${key}Applicable`;

                payload[backendKey] = Boolean(billingData[`${key}Applicable`]);
            });

            const url =
                billingData.id && billingData.id !== 0
                    ? "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/billing/update"
                    : "http://10.10.20.9:7007/caterings-0.0.1-SNAPSHOT/api/admin/billing/create";

            const method = billingData.id && billingData.id !== 0 ? "put" : "post";

            const response = await axios({
                method,
                url,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                data: payload,
            });

            console.log("✅ Billing data saved/updated:", response.data);
            alert("Billing settings saved successfully!");

            // Close the edit mode for this key
            if (key) setEditMode((prev) => ({ ...prev, [key]: false }));
            else setEditMode({});

            // Refresh data from API
            fetchBillingData();
        } catch (error) {
            console.error(
                "❌ Error saving/updating billing data:",
                error.response?.data || error.message
            );
            alert(
                `Failed to save/update billing settings: ${error.response?.data?.message || error.message}`
            );
        } finally {
            setLoading(false);
        }
    };


    return (
        <div style={containerStyle}>
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={headerStyle}>Charge Type</th>
                        <th style={headerStyle}>Percentage (%)</th>
                        <th style={headerStyle}>Visibility</th>
                        <th style={headerStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {billingFields.map(({ label, key }) => (
                        <tr key={key}>
                            <td style={cellStyle}>
                                <strong>{label}</strong>
                            </td>
                            <td style={cellStyle}>
                                {editMode[key] ? (
                                    <input
                                        type="number"
                                        value={billingData[key] || ""}
                                        onChange={(e) => handleValueChange(key, e.target.value)}
                                        style={inputStyle}
                                    />
                                ) : (
                                    <span>{billingData[key] || "—"}</span>
                                )}
                            </td>
                            <td style={cellStyle}>
                                <input
                                    type="checkbox"
                                    checked={Boolean(billingData[`${key}Applicable`])}
                                    disabled={!editMode[key]}
                                    onChange={() => handleCheckboxChange(key)}
                                />
                            </td>
                            <td style={cellStyle}>
                                {editMode[key] ? (
                                    <FaSave
                                        onClick={() => handleSaveOrUpdate(key)}
                                        style={{ ...iconStyle, color: "#4caf50" }}
                                        title="Save"
                                    />
                                ) : (
                                    <FaEdit
                                        onClick={() => toggleEdit(key)}
                                        style={{ ...iconStyle }}
                                        title="Edit"
                                    />
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
                <button
                    onClick={() => handleSaveOrUpdate()}
                    style={saveButtonStyle}
                    onMouseOver={(e) => (e.target.style.backgroundColor = "#45a049")}
                    onMouseOut={(e) => (e.target.style.backgroundColor = "#4CAF50")}
                >
                    Save All
                </button>
            </div>
        </div>
    );
};

// Styles
const containerStyle = { maxWidth: 1200, margin: "0 auto", fontFamily: "Segoe UI, sans-serif" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const headerStyle = { background: "#b15cd6", color: "#fff", padding: 10, border: "1px solid #ddd", textAlign: "center" };
const cellStyle = { padding: 10, border: "1px solid #ddd", textAlign: "center" };
const inputStyle = { width: 100, padding: 5, border: "1px solid #ccc", borderRadius: 5, textAlign: "center" };
const iconStyle = { fontSize: 18, cursor: "pointer" };
const saveButtonStyle = {
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: 5,
    cursor: "pointer",
    fontWeight: "bold",
    transition: "background-color 0.3s",
};

export default Cateringbillingsetup;
